/**
 * Presentation maths for the brand dashboard's campaign KPI cards. The figures
 * themselves (ROAS, eCPM, cheaper multiple) come from the dashboard KPIs API so
 * the dashboard and the campaign detail page cannot disagree; only the bar
 * geometry is decided here.
 */

/** Bar width as a percentage of the row maximum, clamped to 0-100. */
export const barPercent = (value: number, max: number): number =>
  max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
